import apiClient from './apiClient';
import { API_CONFIG } from '../config';

function buildQuery(params) {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.set(key, value);
    }
  });

  const queryString = query.toString();
  return queryString ? `?${queryString}` : '';
}

class AvailabilityService {
  async searchSlots({ actorRole, from, to }) {
    const endpoint = `${API_CONFIG.ENDPOINTS.AVAILABILITY.SEARCH_SLOTS}${buildQuery({ actorRole, from, to })}`;
    const response = await apiClient.get(endpoint);
    return response.data || [];
  }

  async getMySlots({ from, to } = {}) {
    const endpoint = `${API_CONFIG.ENDPOINTS.AVAILABILITY.MY_SLOTS}${buildQuery({ from, to })}`;
    const response = await apiClient.get(endpoint);
    return response.data || [];
  }

  async createSlot(payload) {
    const response = await apiClient.post(API_CONFIG.ENDPOINTS.AVAILABILITY.CREATE_SLOT, payload);
    return response.data;
  }

  async deleteSlot(slotId) {
    await apiClient.delete(API_CONFIG.ENDPOINTS.AVAILABILITY.DELETE_SLOT(slotId));
    return true;
  }
}

const availabilityService = new AvailabilityService();

export default availabilityService;
